import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { IAuthStore, TSavedUrl } from 'redux/reducers/auth/types';

// ==========================================:
const getAuthState = (state: TStoreState): IAuthStore => state.auth;
export const getAuth = createSelector([getAuthState], (auth: IAuthStore) => auth);

// ====================================================:
export const getIsAuth = createSelector([getAuth], (auth: IAuthStore): boolean => {
	return !!auth.accessToken;
});

// ====================================================:

export const getAuthAccessToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.accessToken,
);

// ====================================================:

export const getAuthRefreshToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.refreshToken,
);

// ====================================================:
export const getAuthIsAuthenticated = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => !!(auth.isAuthenticated && auth.accessToken),
);

// ====================================================:
export const getAuthIsNotAuthenticated = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => !auth.isAuthenticated && !auth.accessToken,
);
export const getSocketToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.socketToken,
);
// ====================================================:
export const getAdminEmail = createSelector(
	[getAuth],
	(auth: IAuthStore): null | string => auth.email,
);

// ====================================================:
export const getIsLoad = createSelector([getAuth], (auth: IAuthStore): boolean => auth.loginLoader);

// ====================================================:
export const getMerchantId = createSelector([getAuthState], (auth: IAuthStore) => auth.xMerchantId);

// ====================================================:
export const getAuthConnect = createSelector([getAuthState], (auth: IAuthStore) => auth.connect);

// ====================================================:

export const getAuthConnectLoader = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.connectLoader,
);

// ====================================================:

export const getAuthPolicy = createSelector([getAuthState], (auth: IAuthStore) => auth.policy);

// ====================================================:

export const getAuthPolicyLoader = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.policyLoader,
);

// ==========================================:

export const getSavedUrl = createSelector(
	[getAuthState],
	(auth: IAuthStore): TSavedUrl => auth.savedUrl,
);

// ==========================================:

export const getRefreshTime = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.refreshTime,
);

// ==========================================:

export const getRefreshTokenLoader = createSelector(
	[getAuthState],
	(auth: IAuthStore) => auth.refreshTokenLoader,
);
// ==========================================:
